import { useEffect } from 'react';
import { useUIStore } from '../../store/ui-store';
import { useUserStore } from '../../store/user-store';
import { CustomerDetails } from '../../components/customers/customer-details';

function CustomerDetailsPage() {
  const { currentUser } = useUserStore();
  const { setTitle, setBreadcrumbs, clearBreadcrumbs } = useUIStore();

  useEffect(() => {
    if (currentUser) {
      setTitle(`${currentUser?.firstName}'s profile`);
      setBreadcrumbs([{ link: '/customers', label: 'All users' }]);
    }
  }, [currentUser, setBreadcrumbs, setTitle]);

  useEffect(
    () => () => {
      clearBreadcrumbs();
    },
    [clearBreadcrumbs],
  );

  return (
    <div className="px-12 pt-10 pb-[35px]">
      <CustomerDetails />
    </div>
  );
}

export default CustomerDetailsPage;
